import { selectRecenterGraphKey } from '../state/HUDSlice';
import { useSelector } from 'react-redux';

const useRecenterGraphKey = () => useSelector(selectRecenterGraphKey);

export default useRecenterGraphKey;
